<template>
    <div class="info_service">
        <pop :is-pop-show.sync = 'showOrder' :isShowButton = "false">
            <div class="server-orderbox" slot="xw-pop-modal-body">
                <h3>{{$lang == 'zh' ? '「大流量服务組合」(学生体验卡专享)订购方式:' : '「大流量服務組合」(學生體驗卡專享)訂購方式:'}}</h3>
                <div class="server-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{{$lang == 'zh' ? '「大流量服务组合」' : '「大流量服務組合」'}}<br>({{$lang == 'zh' ? '学生体验卡专享' : '學生體驗卡專享'}})</th>
                                <th colspan="2">{{$lang == 'zh' ? '启动方法' : '啟動方法'}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <h4>HK$198/10GB/365日</h4>
                                    <p>1.{{$lang == 'zh' ? '香港本地流动数据' : '香港本地流動數據'}}: 10GB/365日</p>
                                    <p>2.{{$lang == 'zh' ? '香港本地语音' : '香港本地話音'}}: 1,000{{$lang == 'zh' ? '分钟' : '分鐘'}}/365日</p>
                                    <p>3.{{$lang == 'zh' ? '身处香港拨打IDD致中国内地' : '身處香港撥打IDD致中國內地'}}: 100{{$lang == 'zh' ? '分钟' : '分鐘'}}/365日</p>
                                </td>
                                <td>{{$lang == 'zh' ? '发短信' : '發短訊'}}「10GBS」</td>
                                <td rowspan="2">致 <strong>(+852)5749 9880</strong></td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>HK$358/20GB/365日</h4>
                                    <p>1.{{$lang == 'zh' ? '香港本地流动数据' : '香港本地流動數據'}}: 20GB/365日</p>
                                    <p>2.{{$lang == 'zh' ? '香港本地语音' : '香港本地話音'}}: 1,500{{$lang == 'zh' ? '分钟' : '分鐘'}}/365日</p>
                                    <p>3.{{$lang == 'zh' ? '身处香港拨打IDD致中国内地' : '身處香港撥打IDD致中國內地'}}: 200{{$lang == 'zh' ? '分钟' : '分鐘'}}/365日</p>
                                </td>
                                <td>{{$lang == 'zh' ? '发短信' : '發短訊'}}「20GBS」</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </pop>
    </div>
</template>

<script>
    import pop from './pop.vue'
    export default {
        components: {
            pop
        },
        props: ['showOrder'],
        watch: {
            showOrder () {
                this.$emit('changeOrder',this.showOrder);
            }
        },
        computed: {
            $lang () {
                return this.$i18n.locale == "zh" ? 'zh' : 'hk';
            }
        },
        data () {
            return {
            }
        }
    }
</script>

<style scoped lang="less">
.server-orderbox {
    width: 870px;
    padding: 0 35px 35px;
    h3 {
        text-align: center;
        font-size: 16px;
        padding: 10px 0 20px;
        border-bottom: 1px solid #eaeaea;
    }
    .server-table {
        table {
            box-sizing: border-box;
            border-collapse: collapse;
            width: 100%;
            th {
                // border: 2px solid #fff;
                &:first-child {
                    border-right: 2px solid #fff;
                }
                background-image: linear-gradient(to right, #00a0e9, #00daff);
                padding: 20px 15px;
                text-align: center;
                color: #fff;
            }
            td {
                border: 2px solid #d2d2d2;
                padding: 20px 15px;
                h4 {
                    font-size: 18px;
                    color: #00a3ea;
                    margin-bottom: 10px;
                }
                strong {
                    color: #0054a6;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/serverOrder.vue